import React, { ReactElement } from "react";
import { Button, ButtonProps, Image, ImageProps } from "react-bootstrap";
import "./SecondaryActionButton.scss";

type SecondaryActionButtonProps = ButtonProps & {
  text: string;
  buttonClassName?: string;
  isExternal?: boolean;
  leftImage?: string | ReactElement;
  rightImage?: string | ReactElement;
  leftImageProps?: ImageProps;
  rightImageProps?: ImageProps;
};

export default function SecondaryActionButton({
  text,
  isExternal,
  buttonClassName = "",
  leftImage,
  rightImage,
  leftImageProps,
  rightImageProps,
  ...restProps
}: SecondaryActionButtonProps) {
  return (
    <Button
      target={isExternal ? "_blank" : undefined}
      rel={isExternal ? "noopener noreferrer" : undefined}
      className={`SecondaryButton ${buttonClassName}`}
      {...restProps}
    >
      {leftImage &&
        (typeof leftImage === "string" ? (
          <Image src={leftImage} alt="button image" {...leftImageProps} />
        ) : (
          leftImage
        ))}{" "}
      {text}{" "}
      {rightImage &&
        (typeof rightImage === "string" ? (
          <Image src={rightImage} alt="button image" {...rightImageProps} />
        ) : (
          rightImage
        ))}{" "}
    </Button>
  );
}
